import { PropsWithChildren, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { Grid, IconButton, Typography } from "@mui/material"
import { faCircleXmark } from "@fortawesome/pro-thin-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { CreateOrderDialogFlow, CreateOrderFlowType } from "../createOrderTypes"
import { ConfirmModal } from "../../dialogs/ConfirmModal"

export const CREATE_ORDER_TOP_BAR_HEIGHT = "4.625rem"

const useStyles = makeStyles()((theme) => ({
    headerWrap: {
        padding: "0.75rem",
        paddingLeft: ".5rem",
        background: theme.palette.common.white,
        borderBottom: `1px solid ${theme.palette.tailwind.slate[400]}`,
        height: CREATE_ORDER_TOP_BAR_HEIGHT,
    },
    closeIcon: {
        color: theme.palette.tailwind.slate[600],
        fontSize: "2rem",
    },
    classNameOverride: {
        padding: "1.25rem 1.5rem 3.25rem",
    },
}))

type CreateOrderDialogTitleProps = Readonly<
    PropsWithChildren<{
        handleClose: () => void
        isDirtyForm?: boolean
        flowConfig?: CreateOrderDialogFlow
    }>
>

export function CreateOrderDialogTitle({
    handleClose,
    isDirtyForm = false,
    children,
    flowConfig,
}: CreateOrderDialogTitleProps) {
    const { classes } = useStyles()
    const [showConfirmModal, setShowConfirmModal] = useState(false)

    return (
        <>
            <Grid
                container
                className={classes.headerWrap}
                alignItems="center"
                justifyContent="space-between"
                flexWrap="nowrap"
                gap=".5rem"
            >
                {flowConfig?.flow !== CreateOrderFlowType.OUTLOOK && (
                    <IconButton onClick={() => (isDirtyForm ? setShowConfirmModal(true) : handleClose())}>
                        <FontAwesomeIcon icon={faCircleXmark} className={classes.closeIcon} />
                    </IconButton>
                )}
                {children}
            </Grid>
            {showConfirmModal && (
                <LocalizedStrict
                    id="create-order-close-confirm-dialog"
                    attrs={{ title: true, buttonLabelSubmit: true }}
                >
                    <ConfirmModal
                        open={showConfirmModal}
                        onClose={() => setShowConfirmModal(false)}
                        handleClick={handleClose}
                        title="Discard changes"
                        message={
                            <LocalizedStrict id="create-order-close-confirm-dialog-message">
                                <Typography variant="body1">
                                    If you click Discard, all entered information will be lost.
                                </Typography>
                            </LocalizedStrict>
                        }
                        buttonLabelSubmit="Discard"
                        classNameOverride={classes.classNameOverride}
                    />
                </LocalizedStrict>
            )}
        </>
    )
}
